import { ButtonLink, DetailsIcon } from '@razz-team/ui-web';
import { useTranslation } from 'react-i18next';
import { ApiCard } from '../../../openapi';

export function isDetailsAvailable(card: ApiCard) {
  return card.status === 'ACTIVE';
}

export function CardDetailsButton({ card }: { card: ApiCard }) {
  const { t } = useTranslation();

  return (
    <ButtonLink
      to="/account/cards/$cardId/details"
      params={{ cardId: card.id }}
      color="secondary"
      startIcon={<DetailsIcon />}
    >
      {t('Details')}
    </ButtonLink>
  );
}
